$(document).ready(function () {
    if (window.innerWidth < 992) {
        $('[data-aos-delay]').attr('data-aos-delay', '0').css('transition-delay', '0ms');
        $('[data-aos]').addClass('aos-animate');
        return;
    }

    AOS.init({
        duration: 600,
        once: true,
    });
});
